<template>
  <div class="inventory">
    <div class="col-12">
      <div class="row">
        <div class="col-6">
          <h2>Pots Detail</h2>
        </div>
      </div>
    </div>

    <div class="col-12" v-if="plant_botany">
      <div class="row">
        <div class="col-2">
          <label for="name"> Description: </label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="description"
            ref="description"
            name="name"
            placeholder="name"
            :value="getDescription()"
          /> <!-- create getDescription function -->
        </div>

        <div
          v-if="submitted && errors.has('name')"
          class="col-12 invalid-feedback"
        >
          {{ errors.first("name") }}
        </div>
      </div>
      
      <div class="row">
        <div class="col-2">
          <label for="position"> Botany: </label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="botany"
            ref="botany"
            name="botany"
            placeholder="enter the plant botany"
            :value="getBotany()"
          /> <!-- create getBotany function -->
        </div>
      </div>
    </div>

<div class="row">
      <div class="col-10">
        <button id="new" @click="$emit('new')" class="btn btn-plt"> New </button>
        <button v-if="plant_botany" id="save" @click="save" class="btn btn-plt">
          Save
        </button>
      </div>
      
      <div class="col-2" v-if="plant_botany">
        <button
          id="delete"
          v-if="plant_botany.active"
          @click="_delete"
          class="btn btn-danger"
        >
          Delete
        </button>
        <button id="delete" v-else @click="_delete" class="btn btn-primary">
          Reactivate
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "PlantVarietyDetail",

  // Props
  props: {
    plant_botany: {
      type: Object,
      default: null,
    },
  },

  // DATA
  data: () => ({
    submitted: false
  }),

  // Computed
  computed: {},

  // METHODS
   methods: {
    ...mapActions("inventory", ["apiSavePersonnel","apiCreatePersonnel",]),
    
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.save();       
        }
      });
    },

    _delete() {
      if (this.plant_botany && this.plant_botany.id > 0) {
        this.plant_botany.active = !this.plant_botany.active;
        this.apiSavePersonnel(this.personnel);
      }
    },

    save() {
      if (this.plant_botany) {
        if (!this.$refs.description.value) {
          alert("please enter a name");
          return;
        }
        this.plant_botany.description = this.$refs.description.value;
        this.plant_botany.botany = this.$refs.botany.value;
        this.plant_botany.active = true;

        if (this.plant_botany.id > 0) {
          this.apiSavePersonnel(this.plant_botany);
        } else {
          this.apiCreatePersonnel(this.plant_botany);
        }
        this.$emit("saved");
      }
    },

     getDescription() {
      if (this.plant_botany == null) {
        return "";
      } else {
        return this.plant_botany.description;
      }
    },

     getBotany() {
      if (this.plant_botany == null) {
        return "";
      } else {
        return this.plant_botany.botany;
      }
    },
   },

  // Component
  component: {},
};
</script>
